/*
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import { createAction } from "@reduxjs/toolkit"

import type { InitializeFiltersPayload } from "features/results/HistoricalDataFiltersSlice"
import type { CurrentUserParameters } from "features/userParameters/UserParametersSchemata"
import type { Results } from "services/computations"
import type { InitialScrsTable } from "services/computations/types"
import type { DeepReadonly } from "utils/readonly"

// AIDEV-NOTE: (#1125) Everything a completed submission stores, in one action that the
// initialScrs, lastSubmittedParameters, historicalDataFilters and results slices each handle
// through extraReducers. One action is one reducer call, so the four slices change together
// or not at all; see the note in submitForm (UserParametersForm.tsx) for why that holds. The
// imports above are type-only so that the slices, which import this module, gain no runtime
// import cycle through it.
export type SubmissionCommittedPayload = DeepReadonly<{
  parameters: CurrentUserParameters
  initialScrsTable: InitialScrsTable
  // Non-null only on the submission that initialises the filters. submitForm decides this,
  // once, from the same state it computed `results` against, so the stored filters are
  // always the ones those results were computed with.
  initializeFilters: InitializeFiltersPayload | null
  results: Results
}>

export const submissionCommitted = createAction<SubmissionCommittedPayload>(
  "userParameters/submissionCommitted"
)
